import { MAX_PRICE, STOP_PRODUCT } from '@/common/constant';
import { PRODUCT_STATUS } from '@/model/product';
import { Component, Vue } from 'vue-property-decorator';
import qNotify from "@/common/qNotify";
@Component
class RemoveItemInactive extends Vue {
  items;
  errors;
  isCartPage;
  addCart(arg) { };
  replaceCart(arg) { };
  updateItem(arg) { };

  public checkItemAvaiable() {
    const itemInActive = [];
    const itemListName = [];

    let key = 0;
    this.items.list.map(({ item }) => {
      if (
        item.set_item_code &&
        (
          item.product.status == PRODUCT_STATUS.inActive ||
          STOP_PRODUCT.includes(item.product.master_product.sales_judge_kbn + "")
        )
      ) {
        itemInActive.push(key);
        itemListName.push(
          `<li>${item.set_item_name_1}${item.set_item_name_2}</li>`
        );
      } else if (!item.set_item_code && (item.status == PRODUCT_STATUS.inActive || STOP_PRODUCT.includes(item.master_product.sales_judge_kbn + ""))) {
        itemInActive.push(key);
        itemListName.push(`<li>${item.itemName}</li>`);
      }
      // this.addCart([item]);
      key++;
    });
    if (itemInActive.length > 0) {
      // 閉じる
      this.$modal.showCancel({
        title: "カート製品除外のお知らせ",
        text: `以下の製品が一時販売停止または生産終了となりましたので、カートから削除いたします。<br> <ul style="list-style: disc;padding-left: 20px;">${itemListName.join(
          ""
        )}</ul>`,
        type: "info",
        showQuestion: false,
        showCancelButton: false,
        confirmText: "閉じる",
        confirmClass: "mb__button",
        onConfirm: () => {
          // remove item inactive
          this.replaceCart([]);
          const temp = [];
          this.items.list.map((item, key) => {
            if (
              !itemInActive.includes(key)
            ) {
              temp.push(item);
              this.addCart([item.item]);
            }
          });
          this.items.list = temp;
        },
      });
    }
    return itemInActive.length === 0;
  }

  public canProcess() {
    let flag = 0;

    for (let index = 0; index < this.items.list.length; index++) {
      if (this.isCartPage) {
        this.handleChangeBoomQuantity(
          this.items.list[index].item,
          `cart.${index}.product_quantity`
        );

      } else {
        this.handleChangeBoomQuantity(this.items.list[index].item, `d_slip_cart_orres.${index}.quantity`);
      }
    }

    for (let key of Object.keys(this.errors)) {
      if (this.errors[key].length > 0) {
        flag++;
      }
    }

    if (flag > 0) {
      qNotify.error({
        text: this.$t("cart_page.validate.max_price"),
      });
    }

    return flag === 0;
  }

  public handleChangeBoomQuantity(item: any, key) {
    const total =
      this.items.list
        .filter(
          (cart) =>
            cart.item.set_item_code === item.set_item_code &&
            cart.item.item_code === item.item_code
        )
        /* eslint-disable unicorn/no-array-reduce */
        .reduce((memo, cart) => {
          return cart.item.total + memo;
        }, 0);
    // re-set to vuex
    if (total > MAX_PRICE) {
      this.errors = {
        ...this.errors,
        ...{
          [key]: [this.$t("cart_page.validate.max_price")],
        },
      };
    } else if (!item.cart_quanlity || item.cart_quanlity == 0) {
      this.errors = {
        ...this.errors,
        ...{
          [key]: [
            this.$t("cart_page.messsage.quantity_is_required"),
          ],
        },
      };
    } else {
      this.errors = {
        ...this.errors,
        ...{ [key]: [] },
      };
      this.isCartPage && this.updateItem(item);
    }
  }
}
export default RemoveItemInactive
